var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"technology-assets-amount-table-cell"},[_c('span',{staticClass:"amount",on:{"click":function($event){return _vm.toggleAssetsListPopup(_vm.item)}}},[_vm._v(_vm._s(_vm.assetsAmount))])])
}
var staticRenderFns = []

export { render, staticRenderFns }